var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude } from 'class-transformer';
class MetricUsageInfoResource {
    name; // dashboard name
    id; // dashboard identifier (ID or UID TBD)
}
export class MetricUsageInfo {
    usageType;
    resources;
}
export class MetricMetaData {
    approximateCardinality; // if false - metric cardinality is accurate; otherwise - it displays just the limit of returned TS from m3db and actual value is bigger
    active; // is metric active
    usage;
}
export class MetricLabelCardinality {
    labelName;
    cardinality;
}
export class MetricsAccountData {
    accountId;
    accountName;
}
export class MetricInfoModel {
    id;
    metricName;
    cardinality;
    prevCardinality;
    percentageOfTotal;
    metadata;
    labelCardinality;
    accounts;
    isDroppingInProgress;
}
__decorate([
    Exclude(),
    __metadata("design:type", String)
], MetricInfoModel.prototype, "id", void 0);
__decorate([
    Exclude(),
    __metadata("design:type", Boolean)
], MetricInfoModel.prototype, "isDroppingInProgress", void 0);
//# sourceMappingURL=metrics-insights.js.map